/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditEntry {
    getFixupPrototypeFunction() { return RequestAuditEntry.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditEntry>): RequestAuditEntry {
        let obj = Object.assign(new RequestAuditEntry(), model);
        RequestAuditEntry.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditEntry>): RequestAuditEntry {
        if (!model) return null;
        return RequestAuditEntry.newInstance(<RequestAuditEntry> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditEntry) {
        if (!obj) return;

        models.RequestAuditEntry.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditEntry): boolean {
        Object.setPrototypeOf(obj, RequestAuditEntry.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.status_code === undefined) {
            this.status_code = 0;
        }
        if (this.duration === undefined) {
            this.duration = 0;
        }
        if (this.memory_end === undefined) {
            this.memory_end = 0;
        }
        if (this.memory_delta === undefined) {
            this.memory_delta = 0;
        }
        if (this.overlapping_requests === undefined) {
            this.overlapping_requests = 0;
        }
        if (this.active_requests_at_start === undefined) {
            this.active_requests_at_start = 0;
        }
        if (this.active_requests_at_end === undefined) {
            this.active_requests_at_end = 0;
        }
        if (typeof this.start_time === "string") {
            this.start_time = new Date(<string><any>this.start_time);
        }
        if (typeof this.end_time === "string") {
            this.end_time = new Date(<string><any>this.end_time);
        }
        if (this.cache) {
            models.RequestAuditCacheCounters.fixupPrototype(this.cache);
        }
        if (this.observability) {
            models.RequestAuditEndpointObservability.fixupPrototype(this.observability);
        }
    }

    /**
     * The executor for this request
     */
    executor: models.BackgroundJobExecutor;

    /**
     * Request Endpoint
     */
    endpoint: string;

    /**
     * Result of the request
     */
    status_code: number;

    /**
     * Request verb
     */
    method: string;

    /**
     * Resource path
     */
    path: string;

    /**
     * Query parameters
     */
    params: { [key: string]: string; };

    /**
     * Source IP
     */
    source_ip: string;

    /**
     * Correlation ID
     */
    request_id: string;

    /**
     * Caller origin (X-Source-Type). Absent on legacy/uncorrelated requests.
     */
    source_type: models.SourceType;

    /**
     * Groups all requests belonging to one business transaction (X-Correlation-ID). Absent on legacy/uncorrelated requests.
     */
    correlation_id: string;

    /**
     * Dashboard GUID (X-Page-ID). Present only when source_type is UI.
     */
    page_id: string;

    /**
     * Widget GUID (X-Component-ID). Present only when source_type is UI.
     */
    component_id: string;

    /**
     * Agent identifier (X-Agent-ID). Present only when source_type is Agent.
     */
    agent_id: string;

    /**
     * User ID
     */
    user_id: string;

    /**
     * User name
     */
    user_name: string;

    /**
     * Source service
     */
    from_service: string;

    /**
     * Start time
     */
    start_time: Date;

    /**
     * End time
     */
    end_time: Date;

    /**
     * Duration in seconds
     */
    duration: number;

    /**
     * Memory used at the end of the request
     */
    memory_end: number;

    /**
     * Memory usage change during the request
     */
    memory_delta: number;

    /**
     * Number of requests that happened at the same time.
     */
    overlapping_requests: number;

    /**
     * Number of requests active at start.
     */
    active_requests_at_start: number;

    /**
     * Number of requests active at end.
     */
    active_requests_at_end: number;

    /**
     * Cache performance counters.
     */
    cache: models.RequestAuditCacheCounters;

    /**
     * Set if there's a profile associated with this request.
     */
    has_profile: boolean;

    /**
     * Profiler output
     */
    profile_html: string;

    /**
     * Request payload.
     */
    payload: string;

    /**
     * Endpoint observability data. Present when observability is enabled for the endpoint.
     */
    observability: models.RequestAuditEndpointObservability;

}
